import { IAdContent } from 'src/interface';

export const ACTIONS = {
    AD_NATIVE_UPDATE: 'AD_NATIVE_UPDATE',
    IS_NOAD_UPDATE: 'IS_NOAD_UPDATE',
}

export const adNativeUpdate = ({
    prZoneIds,
    adData,
}: {
    prZoneIds: string[];
    adData?: IAdContent;
}) => ({
    type: ACTIONS.AD_NATIVE_UPDATE,
    payload: {
        prZoneIds,
        adData,
    },
});

export const isNoAdUpdate = (isNoAd: boolean) => ({
    type: ACTIONS.IS_NOAD_UPDATE,
    payload: isNoAd,
});
